import { PayloadRequest } from 'types/requestTypes';

import { omdApi } from '../api';
import { MethodOfReception, MethodOfReceptionItem, MethodOfReceptionType } from './types';

const request = omdApi.injectEndpoints({
  endpoints: (builder) => ({
    getMethodOfReceptionList: builder.query<MethodOfReceptionItem[], { requestId: string | number }>({
      query: ({ requestId }) => ({
        url: `/v1/MethodOfReception/${requestId}`,
      }),
      providesTags: ['methodOfReceptionList'],
    }),
    getMethodOfReceptionDetail: builder.query<any, PayloadRequest>({
      query: (data) => ({
        url: `/v1/MethodOfReception/${data.id}/details`,
      }),
    }),
    changeMethodOfReception: builder.mutation<void, MethodOfReception>({
      query: (data) => ({
        url: `/v1/MethodOfReception/${data.id}/details`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: ['methodOfReceptionList'],
    }),
    createMethodOfReception: builder.mutation<void, MethodOfReception>({
      query: (data) => ({
        url: '/v1/MethodOfReception',
        method: 'POST',
        body: data,
        params: { requestId: data.requestId },
      }),
      invalidatesTags: ['methodOfReceptionList'],
    }),
    deleteMethodOfReception: builder.mutation<void, PayloadRequest>({
      query: (data) => ({
        url: `/v1/MethodOfReception/${data.id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['methodOfReceptionList'],
    }),
    getMethodOfReceptionTypes: builder.query<MethodOfReceptionType[], void>({
      query: () => ({
        url: '/v1/MethodOfReception/types',
      }),
    }),
  }),
});

export const {
  useChangeMethodOfReceptionMutation,
  useCreateMethodOfReceptionMutation,
  useDeleteMethodOfReceptionMutation,
  useGetMethodOfReceptionDetailQuery,
  useGetMethodOfReceptionListQuery,
  useLazyGetMethodOfReceptionDetailQuery,
  useLazyGetMethodOfReceptionListQuery,
  useGetMethodOfReceptionTypesQuery,
} = request;
